import { Alert, Checkbox, Collapse, Divider, Space } from "antd";
import React from "react";
import BMInput from "../../admin/comps/BMInput";
import ImageSelect from "../../admin/ImageSelect";
import ColourPicker from "./ColourPicker";
import { usePrefs } from "../../utils/Prefs";

export default function Backgrounds(props) {

    const [prefs, setPrefs] = usePrefs(); 
    const { view = "", data = {}, setData = () => { } } = props;

    const {
        background_alt = "",
        background_tile = false,
        background_fixed = false,
        background_image = "",
        background_colour = 0,
        background_container_colour = 0,
        background_container_transparent = false,
    } = data;

    const save = (_val, _key) => {
        setData({ ...data, [_key]: _val });
        setPrefs({ ...prefs, "changed": true });
    }

    // Draw header
    const drawHeader = () => {
        return (
            <div style={{ "alignItems": "center" }} className="float-flex">
                <Space size={0}>
                    <strong>Backgrounds</strong>
                </Space>
            </div>
        )
    }

    const draw = () => {
        return (
            <>
                <Collapse accordion className="subpanel" defaultActiveKey="main_background" expandIcon={({ isActive }) => { return (isActive) ? "-" : "+" }} ghost>
                    <Collapse.Panel header={<div style={{ "color": "#e77e21", "fontSize": "11px" }}>MAIN BACKGROUND</div>} key="main_background">
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                        <ColourPicker allow_none onChange={(_v) => save(_v, "background_colour")} allow_gradient value={background_colour} />
                        <div className="shim" /><div className="shim" />
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND IMAGE</Divider>
                        <div className="shim" />
                        <Alert style={{ "padding": "5px 10px" }} description={<small><em><strong>2560px</strong> wide by <strong>1440px</strong> tall recommended</em></small>} />
                        <div className="shim" />
                        <ImageSelect alt_callback={save} alt={background_alt} alt_name="background_alt" require_alt width={255} onChange={(_v) => save(_v, "background_image")} path={background_image} />
                        
                        {(background_image &&
                            <div>
                                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALT TEXT</Divider>
                                <BMInput value={background_alt} onChange={(_v) => save(_v, "background_alt")} placeholder="Alt text..." width={"100%"} />
                                <div className="shim" />
                            </div>
                        )}
                        <div className="shim" /><div className="shim" />

                        <div className="float-flex-right">
                            <Space>
                                <Checkbox checked={background_fixed} onChange={(e) => save(e.target.checked, "background_fixed")} ><small>Lock in place</small></Checkbox>
                                <Checkbox checked={background_tile} onChange={(e) => save(e.target.checked, "background_tile")} ><small>Tile</small></Checkbox>
                            </Space>
                        </div>
                        <div className="shim" /><div className="shim" />
                    </Collapse.Panel>

                    <Collapse.Panel header={<div style={{ "color": "#e77e21", "fontSize": "11px" }}>CONTAINER BACKGROUND</div>} key="container_background">
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                        <ColourPicker allow_none onChange={(_v) => save(_v, "background_container_colour")} value={background_container_colour} />
                        <div className="shim" /><div className="shim" />
                        <div className="float-flex-right">
                            <Checkbox checked={background_container_transparent} onChange={(e) => save(e.target.checked, "background_container_transparent")} ><small>Transparent</small></Checkbox>
                        </div>
                    </Collapse.Panel>
                </Collapse>
            </>
        )
    }

    return (view === "header") ? drawHeader() : draw();
}